import { attachedFileFragment } from '@reconcept-platform/shared/data-access';
import { gql } from 'apollo-angular';
import { dashboardItemFragment } from '../dashboard/dashboard.fragments';
import { goalCardSummaryItemFragment } from '../goal-card-summary/goal-card-summary.fragments';

export const workspaceItemFragment = gql`
  fragment WorkspaceItemFragment on Workspace {
    id
    title
    alternativeTitle
    shareOnDashboard
  }
`;

export const workspaceViewerCanFragment = gql`
  fragment WorkspaceViewerCanFragment on Workspace {
    id
    viewerCanRead
    viewerCanContribute
    viewerCanManage
  }
`;

export const subDomainToWorkspaceConnectionEdgeFragment = gql`
  fragment SubDomainToWorkspaceConnectionEdge on SubDomainToWorkspaceConnectionEdge {
    node {
      ...WorkspaceItemFragment
      ...WorkspaceViewerCanFragment
    }

    mostSevereSeverity

    goalCardSummaries {
      nodes {
        ...GoalCardSummaryItem
      }
    }
  }
  ${workspaceItemFragment}
  ${workspaceViewerCanFragment}
  ${goalCardSummaryItemFragment}
`;

export const workspaceDetailFragment = gql`
  fragment WorkspaceDetailFragment on Workspace {
    ...WorkspaceItemFragment
    ...WorkspaceViewerCanFragment

    dashboard {
      ...DashboardItemFragment
    }

    description
    accreditationEndDate
    contactEmail
    contactInformation

    attachedFiles {
      ...AttachedFile
    }
  }

  ${dashboardItemFragment}
  ${workspaceViewerCanFragment}
  ${workspaceItemFragment}
  ${attachedFileFragment}
`;
